import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../../images/logo/to-logo.svg";
import "./EventAttendanceDeclineSuccess.css";

const EventAttendanceDeclineSuccess = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const eventName = query.get("event_name") || "the event";
    const email = query.get("email") || "Guest";

    return (
        <div className="decline-wrapper">
            <div className="decline-card">
                <img src={logo} alt="Logo" className="decline-logo" />
                <h1 className="decline-title">❌ Attendance Declined</h1>
                <p className="decline-message">
                    Hi <strong>{email}</strong>, we’ve recorded your decision to not attend <strong>"{eventName}"</strong>.
                </p>
                <p className="decline-note">
                    If you have any questions or need to make changes, please contact the event organizer.
                </p>
            </div>
        </div>
    );
};

export default EventAttendanceDeclineSuccess;